import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl, FormattedMessage } from 'react-intl';

import H1 from 'shared/app/components/h1';
import HeaderCrateWithLogo from 'shared/app/components/header-crate-with-logo';

import messages from './messages';
import resetPasswordMessages from '../reset-password/messages';

const ValidatePasswordResetHeader = ({ intl: { formatMessage } }) => (
  <HeaderCrateWithLogo>
    <Helmet title={formatMessage(resetPasswordMessages.resetPasswordTitle)} />
    <H1 className="text-bold" size="lg">
      <FormattedMessage {...messages.expiredPasswordResetHeading} />
    </H1>
  </HeaderCrateWithLogo>
);

ValidatePasswordResetHeader.displayName = ValidatePasswordResetHeader;

export default injectIntl(ValidatePasswordResetHeader);
